import React, { createContext, useReducer } from 'react';
import PropTypes from 'prop-types';
import ContextDevTool from 'react-context-devtool';
import staffPayratesReducer, { initialState } from '../reducers/staffPayratesReducer';

export const StaffPayratesContext = createContext();

const StaffPayratesProvider = ({ children }) => {
  const useStaffPayratesState = useReducer(staffPayratesReducer, initialState);

  return (
    <StaffPayratesContext.Provider value={[...useStaffPayratesState]}>
      <ContextDevTool
        context={StaffPayratesContext}
        id="StaffPayratesContext"
        displayName="StaffPayrates Context"
      />
      {children}
    </StaffPayratesContext.Provider>
  );
};

StaffPayratesProvider.propTypes = {
  children: PropTypes.element.isRequired,
};

export default StaffPayratesProvider;
